import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "anchorRef", "placement", "modifiers", "portal", "portalElement", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { clsx } from 'clsx';
import { usePopper } from './usePopper';
import { FLIP, PREVENT_OVERFLOW } from './modifiers';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для рендера элемента спозиционированного относительно другого элемента
 *
 * @export
 * @param {IPopperProps} { open, anchorEl, children }
 * @returns
 */
export function Popper(_ref) {
  var open = _ref.open,
    anchorRef = _ref.anchorRef,
    placement = _ref.placement,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? [FLIP, PREVENT_OVERFLOW] : _ref$modifiers,
    _ref$portal = _ref.portal,
    portal = _ref$portal === void 0 ? true : _ref$portal,
    portalElement = _ref.portalElement,
    children = _ref.children,
    divProps = _objectWithoutProperties(_ref, _excluded);
  var host = typeof document !== 'undefined' ? portalElement !== null && portalElement !== void 0 ? portalElement : document.body : null;
  var popper = usePopper({
    open: open,
    anchorRef: anchorRef,
    options: {
      placement: placement,
      modifiers: modifiers
    }
  });
  if (!host || !open) {
    return null;
  }
  var popperElement = /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, divProps), {}, {
    className: clsx(styles['popper'], divProps.className),
    ref: popper.ref,
    children: children
  }));
  return portal ? /*#__PURE__*/ReactDOM.createPortal(popperElement, host) : popperElement;
}